import React from "react";
import { useTranslation } from "react-i18next";

export default function HelpDrawer({
  page,
  completed,
  onClose,
  onStartTour,
  onMarkComplete,
}) {
  const { t } = useTranslation();

  return (
    <div className="academyDrawerLayer">
      <button
        type="button"
        className="academyDrawerBackdrop"
        onClick={onClose}
        aria-label={t("academy_close_guide")}
      />

      <aside
        className="academyDrawer"
        aria-label={t("academy_guide_aria", { title: t(page.title) })}
      >
        <header className="academyDrawerHeader">
          <div className="academyDrawerIdentity">
            <span>{page.icon}</span>
            <div>
              <small>{t("academy_name")}</small>
              <h2>{t(page.title)}</h2>
              <p>{t(page.subtitle)}</p>
            </div>
          </div>

          <button type="button" onClick={onClose} aria-label={t("close")}>
            ×
          </button>
        </header>

        <div className="academyDrawerBody">
          <section className="academyDrawerIntro">
            <p>{t(page.description)}</p>
            <div>
              <span>
                ◷{" "}
                {t("academy_minutes_short", {
                  count: page.estimatedMinutes || 3,
                })}
              </span>
              <span>
                {completed
                  ? t("academy_studied_complete")
                  : t("academy_not_completed")}
              </span>
            </div>
          </section>

          {page.help?.length ? (
            <div className="academyHelpSections">
              {page.help.map((section, index) => (
                <details key={section.id} open={index === 0}>
                  <summary>
                    <span>{String(index + 1).padStart(2, "0")}</span>
                    <strong>{t(section.title)}</strong>
                    <i>⌄</i>
                  </summary>
                  <p>{t(section.body)}</p>
                </details>
              ))}
            </div>
          ) : (
            <div className="academyComingSoon">
              <span>✦</span>
              <strong>{t("academy_lesson_preparing")}</strong>
              <p>{t("academy_lesson_preparing_description")}</p>
            </div>
          )}
        </div>

        <footer className="academyDrawerFooter">
          <button
            type="button"
            className="academySecondaryButton"
            onClick={onMarkComplete}
          >
            {completed
              ? t("academy_mark_not_studied")
              : t("academy_mark_studied")}
          </button>

          <button
            type="button"
            className="academyPrimaryButton"
            onClick={onStartTour}
          >
            {page.steps?.length
              ? t("academy_start_tutorial")
              : t("academy_open_lesson")}
          </button>
        </footer>
      </aside>
    </div>
  );
}
